import { createAction } from '@ngrx/store';

export const RootActions = {
  logout: createAction(
    `Logout`
  ),
}
